import React, { useState } from 'react';
import { TbSteeringWheel } from 'react-icons/tb'

const UpperSeatsData = (props) => {

    const [column1, setColumn1] = useState([{ rowNumber: "", seatNumber: "", seatType: "", seatPrice: "" }])
    const [column2, setColumn2] = useState([{ rowNumber: "", seatNumber: "", seatType: "", seatPrice: "" }])
    const [column3, setColumn3] = useState([{ rowNumber: "", seatNumber: "", seatType: "", seatPrice: "" }])
    const addRow = (column) => {
        if (column === 1) {
            setColumn1([...column1, { rowNumber: "", seatNumber: "", seatType: "", seatPrice: "" }])

        }
        if (column === 2) {
            setColumn2([...column2, { rowNumber: "", seatNumber: "", seatType: "", seatPrice: "" }])

        }
        if (column === 3) {
            setColumn3([...column3, { rowNumber: "", seatNumber: "", seatType: "", seatPrice: "" }])

        }


    }
    const deleteRow = (column, index) => {
        if (column === 1) {
            let list = [...column1]
            list.splice(index, 1)
            setColumn1(list)

        }
        if (column === 2) {
            let list = [...column2]
            list.splice(index, 1)
            setColumn2(list)

        }
        if (column === 3) {
            let list = [...column3]
            list.splice(index, 1)
            setColumn3(list)

        }


    }
    const handleChange = (e, index, column) => {
        if (column === 1) {
            let list = [...column1];
            list[index].rowNumber = index;
            list[index][`${e.target.name}`] = e.target.value;
            setColumn1(list);
        }
        if (column === 2) {
            let list = [...column2];
            list[index].rowNumber = index;
            list[index][`${e.target.name}`] = e.target.value;
            setColumn2(list);
        }
        if (column === 3) {
            let list = [...column3];
            list[index].rowNumber = index;
            list[index][`${e.target.name}`] = e.target.value;
            setColumn3(list);
        }

    }


    return (
        <div className='bg-blue-500 p-6 mt-8'>
            <p className='mt-5 font-bold text-lg'>Upper Seats Data</p>
            <div className='flex gap-20 p-6'>

                <div className='flex flex-col gap-3 '>


                    {column1.map((x, index) => (

                        <div className='bg-white flex flex-col gap-2 p-1  '>
                            <input onChange={(e) => handleChange(e, index, 1)} className='w-[50%] border border-black p-1' name="seatNumber" id="seatNumber" value={x.seatNumber} placeholder='Seat Number' />
                            <input onChange={(e) => handleChange(e, index, 1)} className='w-[50%] border border-black p-1' name="seatType" id="seatType" value={x.seatType} placeholder='Seat Type' />
                            <input onChange={(e) => handleChange(e, index, 1)} className='w-[50%] border border-black p-1' name="seatPrice" id="seatPrice" value={x.seatPrice} placeholder='Price' />
                            <button className='bg-red-500  p-1 text-white' onClick={() => deleteRow(1, index)}>Remove</button>
                        </div>
                    ))}
                    <button className='bg-white  p-1 mb-2' onClick={() => addRow(1)}>Add</button>



                </div>
                <div className='flex flex-col gap-3 '>
                    {column2.map((x, index) => (

                        <div className='bg-white flex flex-col gap-2 p-1  '>
                            <input onChange={(e) => handleChange(e, index, 2)} className='w-[50%] border border-black p-1' name="seatNumber" id="seatNumber" value={x.seatNumber} placeholder='Seat Number' />
                            <input onChange={(e) => handleChange(e, index, 2)} className='w-[50%] border border-black p-1' name="seatType" id="seatType" value={x.seatType} placeholder='Seat Type' />
                            <input onChange={(e) => handleChange(e, index, 2)} className='w-[50%] border border-black p-1' name="seatPrice" id="seatPrice" value={x.seatPrice} placeholder='Price' />
                            <button className='bg-red-500  p-1 text-white' onClick={() => deleteRow(2, index)}>Remove</button>
                        </div>
                    ))}
                    <button className='bg-white  p-1 mb-2' onClick={() => addRow(2)}>Add</button>
                </div>
                <div className='flex flex-col gap-3 '>

                    {column3.map((x, index) => (

                        <div className='bg-white flex flex-col gap-2 p-1  '>
                            <input onChange={(e) => handleChange(e, index, 3)} className='w-[50%] border border-black p-1' name="seatNumber" id="seatNumber" value={x.seatNumber} placeholder='Seat Number' />
                            <input onChange={(e) => handleChange(e, index, 3)} className='w-[50%] border border-black p-1' name="seatType" id="seatType" value={x.seatType} placeholder='Seat Type' />
                            <input onChange={(e) => handleChange(e, index, 3)} className='w-[50%] border border-black p-1' name="seatPrice" id="seatPrice" value={x.seatPrice} placeholder='Price' />
                            <button className='bg-red-500  p-1 text-white' onClick={() => deleteRow(3, index)}>Remove</button>
                        </div>
                    ))}
                    <button className='bg-white  p-1 mb-2' onClick={() => addRow(3)}>Add</button>
                </div>
            </div >
            <p onClick={() => props.onClick(column1, column2, column3)} className='inline cursor-pointer ml-96 mt-2 bg-green-500 text-white p-1 '>SUBMIT</p>
        </div >
    )
}

export default UpperSeatsData;
